// extracted by mini-css-extract-plugin
export var container = "index-module--container--+MMgw";
export var pagination = "index-module--pagination--IhjrX";